import { render, staticRenderFns } from "./employer-verify-otp.vue?vue&type=template&id=9cca63da&"
import script from "./employer-verify-otp.vue?vue&type=script&lang=js&"
export * from "./employer-verify-otp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports